import axios from '../../../../api/axios';
import React,{useState,useEffect} from 'react'
import Formulaire from '../../../ModelesPages/Modele2/FormulaireCours_enseigne_classe'
import Swal from 'sweetalert2';
import {useParams,useNavigate} from 'react-router-dom'

function Update(){

    const [Count,setCount]=useState(0);

    const [classes,setClasses]=useState([])
    const [cours,setCours]=useState([])
    const [cour,setCour]=useState("")
    const [idcour,setIdcour]=useState("")
    const [ponderation,setPonderation]=useState("")
    const [categorie,setCategorie]=useState('')
    const [classe,setClasse]=useState("")
    const [isLoading,setIsLoading]=useState(false)
    const {id}=useParams()
    const navigate=useNavigate()
    
    
    
    useEffect(()=>{
        HandleRequest()
        HandleRequestCours()
        HandleRequestCoursEns()
    },[])
    function handleMouse(e){

        e.target.textContent="Bonjour"
    }
    function handleMouseleave(e){
        e.target.textContent="Soumettre"
    }
    function handlekeyUpgain(e){
    
        const elementss=e.nextElementSibling;
      
    }
    function handleclick(){
        alert('You have clicked me')
    }
    const HandleRequest=async()=>{
        await axios.get('api/classeinitiale').then((res)=>{
            setClasses(res.data.items)
        }).catch((err)=>{

        })
    }
    const HandleRequestCours=async()=>{
        await axios.get('api/Cours').then((res)=>{
            setCours(res.data.items)
        }).catch((err)=>{

        })
    }
    function confirmSave(e){
        e.preventDefault()
        if(classe !="" && cours!="" && ponderation!=""){
            
        Swal.fire({
            title:'Demande de confirmation',
            text:'Voulez-vous vraiment enregistrer ce cours dans cette classe ?',
            icon:'question',
            showCancelButton:true,
            showConfirmButton:true,
            confirmButtonText:'Confirmer',
        }).then((resultat)=>{
            if(resultat.isConfirmed){
                setIsLoading(true)
                HandleSubmit()
            }
        })  
        }
        else{
            Swal.fire({
                title:'Erreur de soumission',
                text:'Veuillez d\'abord compléter tous les champs',
                icon:'warning'
            })
        }
    }
    const HandleRequestCoursEns=async()=>{
        await axios.get(`api/Coursenseigneclasse/${id}`).then((res)=>{
            setClasse(res.data.items[0].idclasse_initiale)
            setCour(res.data.items[0].cours)
            setIdcour(res.data.items[0].idcours)
            setPonderation(res.data.items[0].ponderation)
            setCategorie(res.data.items[0].categorie)
         
        }).catch((err)=>{
            
        })
    }
  
    const HandleSubmit=async (e)=>{
       
                await axios.put(`api/Coursenseigneclasse/${id}`,{cour:cour,classe:classe,ponderation:ponderation,categorie:categorie,idcour:idcour}).then((res)=>{
                    setClasse("")
                    setCour("")
                    setPonderation("")
                    setCategorie("")
                    if(res.data.status_code===200){
                        setIsLoading(false)
                        Swal.fire({
                            title:'Message de confirmation',
                            text:'Le cours a été mis à jour avec succès',
                            icon:'success'
                            
                        })
                        navigate('/Mes_Cours-Classe')
                    }
                    else{
                            setIsLoading(false)
                        Swal.fire({
                            title:'Message d\'erreur',
                            text:res.data.status_message,
                            icon:'error'
                            
                        })
                    }
                     
                }).catch((err)=>{
                        setIsLoading(false)
                        Swal.fire({
                            title:'Message d\'erreur',
                            text:err?.response?.data?.message,
                            icon:'error'
                            
                        })
                        
                })
    }
    return(
    <>
    <Formulaire title="Mis à jour du cours : " onclick={handleclick} isLoading={isLoading}  confirmSave={confirmSave} categorie={categorie} setCategorie={setCategorie} setClasse={setClasse} handlekeyUpgain={handlekeyUpgain}  classe={classe}  handleMouse={handleMouse} Count={Count} setCount={setCount} handleMouseleave={handleMouseleave} HandleSubmit={HandleSubmit} ponderation={ponderation} setPonderation={setPonderation} cour={cour} setCour={setCour} cours={cours}  classes={classes} >
        <div className="w-full md:w-1/1 px-3  md:mb-0">
        
        <div id="resultat" className="block text-red-700"></div>
        <div id="erreur" className="block text-red-500"></div>
    </div>
    </Formulaire>
    </>
    )
}
export default Update